"use client";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { TabView, TabViewInfo } from "../TabView";
import { ConstrainedContent } from "../layout/ConstrainedContent";
import ArchivedActivityImagesList from "./ArchivedActivityImagesList";
import DraftActivityImagesList from "./DraftActivityImagesList";
import PublishedActivityImagesList from "./PublishedActivityImagesList";
import { useGetUserAccessLevel } from "../../hooks/useGetUserAccessLevel";

const ActivityImagesTabView = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const accessLevel = useGetUserAccessLevel();

  const activityViewFromParam = searchParams.get("view");
  const activityView =
    activityViewFromParam === "drafts" || activityViewFromParam === "archived"
      ? activityViewFromParam
      : "published";

  const tabInfos: TabViewInfo[] = [
    { text: t("published"), value: "published" },
    { text: t("drafts"), value: "drafts" },
  ];

  if (accessLevel >= 3) {
    tabInfos.push({ text: t("archivedListTab"), value: "archived" });
  }

  return (
    <div>
      <ConstrainedContent>
        <TabView
          tabInfos={tabInfos}
          defaultTabValue={activityView}
          onTabChange={() => undefined}
        />
      </ConstrainedContent>
      {activityView === "published" && <PublishedActivityImagesList />}
      {activityView === "drafts" && <DraftActivityImagesList />}
      {accessLevel >= 3 && activityView === "archived" && (
        <ArchivedActivityImagesList />
      )}
    </div>
  );
};

export default ActivityImagesTabView;
